import { NavLink, useNavigate, Outlet } from "react-router-dom";
import {
  LayoutDashboard, Inbox, Flame, Sparkles, Newspaper, HelpCircle,
  Star, Settings, LogOut, ExternalLink, Wand2,
} from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/admin", end: true, label: "Dashboard", icon: LayoutDashboard },
  { to: "/admin/enquiries", label: "Enquiries", icon: Inbox },
  { to: "/admin/blog-builder", label: "AI Blog Builder", icon: Wand2 },
  { to: "/admin/poojas", label: "Poojas", icon: Flame },
  { to: "/admin/guidance", label: "Guidance", icon: Sparkles },
  { to: "/admin/blogs", label: "Blogs", icon: Newspaper },
  { to: "/admin/faqs", label: "FAQs", icon: HelpCircle },
  { to: "/admin/testimonials", label: "Testimonials", icon: Star },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

const AdminLayout = () => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const doLogout = () => { logout(); navigate("/admin/login"); };

  return (
    <div className="min-h-screen flex bg-[#FAFAF8]">
      <aside className="w-60 shrink-0 bg-secondary text-white/80 flex flex-col fixed h-screen">
        <div className="px-6 py-6 flex items-center gap-2.5 border-b border-white/10">
          <img src="/logo.png" alt="Shrigokarnam" className="h-9 w-9 object-contain" />
          <span className="font-heading text-xl text-white">Shrigokarnam</span>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-nav-${n.label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium transition-colors ${isActive ? "bg-primary text-white" : "hover:bg-white/10 hover:text-white"}`}>
              <n.icon className="h-4 w-4" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="px-3 py-4 border-t border-white/10 space-y-1">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 rounded-md px-3 py-2.5 text-sm hover:bg-white/10 hover:text-white"><ExternalLink className="h-4 w-4" /> View Site</a>
          <button onClick={doLogout} data-testid="admin-logout" className="w-full flex items-center gap-3 rounded-md px-3 py-2.5 text-sm hover:bg-white/10 hover:text-white"><LogOut className="h-4 w-4" /> Logout</button>
        </div>
      </aside>
      <div className="flex-1 ml-60">
        <header className="h-16 border-b border-border bg-white flex items-center justify-between px-8 sticky top-0 z-10">
          <span className="text-sm text-muted-foreground">Admin Panel</span>
          <span className="text-sm font-medium text-secondary">{user?.email}</span>
        </header>
        <main className="p-8"><Outlet /></main>
      </div>
    </div>
  );
};

export default AdminLayout;
